import { Map } from 'immutable';
import { IDisposable } from 'common/disposable';

export interface IMethodRouter extends IDisposable {
    viewName?: string;

    register: (name: string, control: any) => any;
    invoke: (owner: string, action: string, parameter: any, done: () => void) => void;
}

export class MethodRouter implements IMethodRouter  {
    private registry = Map<string, any>();

    private parent: IMethodRouter;

    viewName: string;

    private disposed = false;

    constructor(parent: IMethodRouter, viewName: string) {
        this.parent = parent;
        this.viewName = viewName;
    }

    register(name: string, control: any) {
        if (this.disposed)
            return;

        this.registry = this.registry.set(name, control);
    }

    invoke(owner: string, action: string, parameter: any, done: () => void) {
        if (this.disposed)
            return;

        var control = this.registry.get(owner);

        if (!control && this.parent !== null) {
            this.parent.invoke(owner, action, parameter, done);
            return;
        }

        var async = control[action].length === 2;

        if (async) {
            control[action](parameter, done);
        } else {
            control[action](parameter);
            done();
        }
    }

    dispose() {
        this.disposed = true;
        this.registry = undefined;
    }
}

// CLEAN UP
export class MockMethodRouter implements IMethodRouter {
    register(name: string, control: any): any {}

    invoke(owner: string, action: string, parameter: any, done: () => void): any {}

    dispose() { }
}